import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import FlightProvider from '../entities/flight/flightProvider';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface FlightProviderState extends ListState<FlightProvider> {
  flightProvider: FlightProvider;
  editFlightProvider: FlightProvider;
}

class FlightProviderMutations extends ListMutations<FlightProvider> {}

class FlightProviderModule extends ListModule<
  FlightProviderState,
  any,
  FlightProvider
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<FlightProvider>(),
    loading: false,
    editFlightProvider: new FlightProvider(),
    selectFlightProvider: new FlightProvider(),
  };
  actions = {
    async selectFlightProvider(
      context: ActionContext<FlightProviderState, any>,
      payload: any
    ) {
      context.state.editFlightProvider = payload.data;
    },

    async saveFlightProvider(
      context: ActionContext<FlightProviderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveFlightProvider',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightProvider>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateFlightProvider(
      context: ActionContext<FlightProviderState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Flight/UpdateFlightProvider',
        payload.data
      );

      let page = reponse.data.result as PageResult<FlightProvider>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getFlightProviders(
      context: ActionContext<FlightProviderState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetFlightProviders',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<FlightProvider>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteFlightProvider(
      context: ActionContext<FlightProviderState, any>,
      payload: any
    ) {
      await Ajax.delete(
        '/api/services/app/Flight/DeleteFlightProvider?input=' + payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: FlightProviderState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: FlightProviderState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const flightProviderModule = new FlightProviderModule();
export default flightProviderModule;
